<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';

const props = defineProps({
  tabs: {
    type: Array,
    required: true,
  },
  activeTab: {
    type: Number,
    default: 0, // 1번째 탭 디폴트
  },
  size: {
    type: String,
    default: 'default', // "default" | "small"
  },
});

const emit = defineEmits(['tabClick']);
const { t } = useI18n();
const translatedTabs = computed(() => props.tabs.map((tab) => t(tab)));

const handleTabClick = (index) => {
  emit('tabClick', index);
};
</script>

<template>
  <div class="web-tab-wrap mb-8">
    <button
      v-for="(tab, index) in translatedTabs"
      :key="index"
      class="tab"
      :class="{ on: index === activeTab }"
      @click="handleTabClick(index)"
    >
      {{ tab }}
    </button>
  </div>
</template>

<style scoped lang="scss">
.tab-container {
  display: flex;
  width: 100%;
  margin-bottom: 1rem;
  overflow-x: auto;
  flex-shrink: 0;
}

.tab-button {
  display: flex;
  justify-content: center;
  align-items: center;
  width: fit-content;
  height: fit-content;
  color: var(--font-dimmer);
  padding: 0.5rem 1.5rem;
  border-bottom: 2px solid var(--border-default);
  word-break: keep-all;
  vertical-align: middle;
  white-space: nowrap;
  overflow: hidden;
  flex-shrink: 0;
}

.tab-button.active {
  color: var(--font-primary);
  border-bottom: 2px solid var(--border-primary);
}

.tab-button:hover {
  color: var(--font-dim);
  border-bottom: 2px solid var(--border-dark);
}

.tab-button.active:hover {
  color: var(--font-primary);
  border-bottom: 2px solid var(--border-primary);
}

.tab-button.small {
  padding: 0.25rem 1rem;
  width: fit-content;
}

.label.small {
  font-size: $font-size-psmall;
  line-height: $line-height-psmall;
  font-weight: $font-weight-medium;
}
</style>
